<template>
  <div class="home">
    <div class="text-xl md:text-xl text-center mt-16 px-4 md:px-0">
      <div class="leading-loose tracking-wide">
        2000 points are distributed to pool every day between LPs, every
        {{ priceToMint }}
        points you can redeem a unique Raphy. (you need to own at least 1
        vNFT to stake and unstake.)
      </div>

      <div
        v-if="oldStaked != '0'"
        class="leading-loose tracking-wide mt-1 text-red-400 mt-4"
      >
        To get double bonus (only Nov 10th), click on unstake from old contract
        and move your LP tokens to new contract.
        <div class="md:px-2 md:py-0 py-2">
          <button @click="redeemOld()" class="btn">
            Unstack from old contract
          </button>
        </div>
      </div>

      <!-- <div>
        Join
        <a
          href="https://discord.gg/kfByfux"
          target="_blank"
          class="hover:underline"
          >discord</a
        >
        for the discussion.
      </div>-->
    </div>
    <div
      class="text-2xl flex flex-col flex-wrap md:flex-row md:-mx-3 md:justify-center items-center mt-6 text-center"
    >
      <div class="md:w-1/3 w-4/5 p-3 md:px-3">
        <div
          class="rounded flex justify-center items-center border-2 p-4 border-gray-900 flex-col shadow-xl bg-white bg-opacity-25"
        >
          <img
            src="https://gallery.verynifty.io/api/image/lp2.svg"
            alt="Raphy"
            class="object-contain mb-6"
            style="height: 230px"
          />
          <p class="mb-6 text-2xl">🦄 MUSE-ETH</p>
          <p class="mb-6">
            Your wallet:
            <TokenBalance
              :erc20="UniEthMuseToken"
              :account="account"
              symbol="$ULP"
              decimals="18"
            />
          </p>
          <div class="flex -mx-3">
            <!-- <div class="px-3">
          
            // </div>-->
            <div class="px-3">
              Staked:
              <Number decimals="18" :number="staked" />
            </div>

            <div class="px-3">
              Rewards:
              <Number decimals="18" :number="pendingMuse" />
            </div>
          </div>

          <div
            class="flex md:flex-row flex-col md:items-start items-center md:-mx-2 -my-2 py-4 mt-4 mb-8 text-sm"
          >
            <div class="md:px-2 md:py-0 py-2">
              <button class="btn">
                <span class v-if="!hasTokenApproval" @click="stake()"
                  >Approve & Stake</span
                >
                <span class v-if="hasTokenApproval" @click="stake()"
                  >Stake</span
                >
              </button>
            </div>
            <div class="md:px-2 md:py-0 py-2">
              <button @click="unstake()" class="btn">Unstake</button>
            </div>

            <div class="md:px-2 md:py-0 py-2">
              <button @click="redeem()" class="btn">
                Redeem for {{ priceToMint }} points
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NFTList from "@/components/NFTList.vue";
import TokenBalance from "@/components/TokenBalance.vue";
import Number from "@/components/Number.vue";

export default {
  name: "Stake",
  components: {
    NFTList,
    TokenBalance,
    Number,
  },
  data: function () {
    return {
      hasTokenApproval: false,
      loader: false,
      staked: "0",
      pendingMuse: "0",
      userLpBalance: "0",
      priceToMint: 400,
      pointsPerDay: 2000,
      oldStaked: "0",
      oldPendingMuse: "0",
    };
  },
  created: function () {},
  mounted: async function () {
    this.init();
  },
  methods: {
    init: async function () {
      // console.log(infos);
      if (this.$store.state.web3 == null) {
        return;
      }
      this.hasTokenApproval =
        (
          await this.$store.state.UniEthMuseContract.methods
            .allowance(
              this.$store.state.account,
              this.$store.state.contracts.VnftLp
            )
            .call()
        ).length >= 18;

      const staked = await this.$store.state.VnftLpContract.methods
        .userInfo(0, this.$store.state.account)
        .call();

      this.staked = staked.amount;

      const oldStaked = await this.$store.state.VnftLpOldContract.methods
        .userInfo(0, this.$store.state.account)
        .call();
      this.oldStaked = oldStaked.amount;

      this.oldPendingMuse = await this.$store.state.VnftLpOldContract.methods
        .pendingPoints(0, this.$store.state.account)
        .call();

      this.pendingMuse = await this.$store.state.VnftLpContract.methods
        .pendingPoints(0, this.$store.state.account)
        .call();

      const userLpBalance = await this.$store.state.UniEthMuseContract.methods
        .balanceOf(this.$store.state.account)
        .call();

      this.userLpBalance = userLpBalance;
      console.log(userLpBalance);
      // alert(this.userLpBalance)
    },
    redeemOld: async function () {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        if (!this.hasTokenApproval) {
          await this.approve();
        }
        let minetx = await this.$store.state.VnftLpOldContract.methods
          .withdraw(0)
          .send({
            from: this.$store.state.account,
          });
        this.init;
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Success",
          text: `TX Hash: ${minetx.blockHash}`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    stake: async function () {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });

        if (!this.hasTokenApproval) {
          await this.approve();
        }
        const userLpBalance = await this.$store.state.UniEthMuseContract.methods
          .balanceOf(this.$store.state.account)
          .call();

        this.userLpBalance = userLpBalance;
        let minetx = await this.$store.state.VnftLpContract.methods
          .deposit(0, this.userLpBalance)
          .send({
            from: this.$store.state.account,
          });
        console.log(minetx);
        this.loader.hide();

        this.$notify({
          group: "foo",
          title: "Success",
          text: `TX Hash: ${minetx.blockHash}`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    unstake: async function () {
      try {
        if (!confirm("Unstaking will reset your earned points")) {
          return false;
        }

        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });

        if (!this.hasTokenApproval) {
          await this.approve();
        }
        let minetx = await this.$store.state.VnftLpContract.methods
          .withdraw(0)
          .send({
            from: this.$store.state.account,
          });
        console.log(minetx);
        this.loader.hide();

        this.$notify({
          group: "foo",
          title: "Success",
          text: `TX Hash: ${minetx.blockHash}`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    redeem: async function () {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });

        if (!this.hasTokenApproval) {
          await this.approve();
        }
        let minetx = await this.$store.state.VnftLpContract.methods
          .redeem(0)
          .send({
            from: this.$store.state.account,
          });
        console.log(minetx);
        this.loader.hide();

        this.$notify({
          group: "foo",
          title: "Success",
          text: `TX Hash: ${minetx.blockHash}`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    approve: async function () {
      let max =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let remove = "0";
      let approve = await this.$store.state.UniEthMuseContract.methods
        .approve(this.$store.state.contracts.VnftLp, max)
        .send({
          from: this.$store.state.account,
        });
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
    UniEthMuseToken: function () {
      return this.$store.state.contracts.UniEthMuse;
    },
    account: function () {
      return this.$store.state.account;
    },
  },
  watch: {
    isConnected: function () {
      this.init();
    },
  },
};
</script>
